import liff from '@line/liff';
import { constants } from '../../constants';

export const getLIFFProfile = async () => {
  await liff.init({
    liffId: constants.liffId,
    withLoginOnExternalBrowser: false,
  });

  if (!liff.isLoggedIn()) {
    return liff.login();
  }

  const { friendFlag } = await liff.getFriendship();
  if (friendFlag) {
    return liff.getProfile();
  }

  const here = window.location.href;
  const timestamp = Date.now();
  window.location.assign(
    `https://access.line.me/oauth2/v2.1/authorize?response_type=code&client_id=${constants.channelId}&redirect_uri=${here}&state=${timestamp}&bot_prompt=aggressive&scope=profile%20openid&prompt=consent`
  );
};
